import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: 'What is vermicompost?',
            answer: 'Vermicompost is a natural soil improver made when earthworms break down organic waste. It helps soil become loose and healthy, increases good microbes, and gives nutrients slowly to plants.'
        },
        {
            question: 'How much vermicompost should I mix with soil?',
            answer: 'For normal use, mix 10–20% vermicompost with garden soil. If the soil is weak or poor, you can add a little more for better growth.'
        },
        {
            question: 'How much vermicompost should be used for potted plants?',
            answer: 'Mix 1 part vermicompost with 4–5 parts soil or potting mix. You can also spread a thin layer on top of the soil. For best results, use our potting mixture.'
        },
        {
            question: 'How often should vermicompost be applied?',
            answer: 'Vermicompost can be used once every 30–45 days. Since it works slowly, there is no need to apply it often.'
        },
        {
            question: 'Is vermicompost safe for vegetables and fruits?',
            answer: 'Yes. Vermicompost is completely natural and safe for vegetables, fruits, flowers, and indoor plants. It does not leave any harmful residue.'
        },
        {
            question: 'What is the difference between normal and premium vermicompost?',
            answer: 'Premium vermicompost is prepared with more time for decomposition and curing. It has a finer texture and better quality compared to regular vermicompost.'
        },
        {
            question: 'Can vermicompost be used for all plants?',
            answer: 'Yes. It can be used for vegetables, fruits, flowers, indoor plants, lawns, and trees. The quantity can be adjusted based on plant size.'
        },
        {
            question: 'Does vermicompost have any smell?',
            answer: 'Good vermicompost has a mild, earthy smell. A bad smell usually means too much moisture or that it is not fully ready.'
        },
        {
            question: 'Can vermicompost replace chemical fertilizers?',
            answer: 'Vermicompost improves soil health over time and can reduce the need for chemical fertilizers. For home gardens and organic farming, it can be used as a main nutrient source.'
        },
        {
            question: 'Is your vermicompost chemical-free?',
            answer: 'Yes. Our vermicompost is made naturally without using any chemicals.'
        },
        {
            question: 'Can vermicompost be applied directly to plants?',
            answer: 'Vermicompost should not be placed directly on the plant stem. It is best mixed into the soil or spread lightly around the plant base.'
        },
        {
            question: 'Is vermicompost suitable for indoor plants?',
            answer: 'Yes. Vermicompost is safe for indoor plants when used in small amounts. For best results, use our potting mixture.'
        },
        {
            question: 'How should vermicompost be stored?',
            answer: 'Keep vermicompost in a cool and shaded place. It should stay slightly moist and should not be stored in airtight bags.'
        },
        {
            question: 'Can vermicompost improve soil quality over time?',
            answer: 'Yes. Regular use helps soil hold water better, improves structure, and supports healthy plant growth.'
        },
        {
            question: 'Is vermicompost safe for long-term use?',
            answer: 'Yes. Vermicompost is safe to use regularly and does not harm soil when used properly.'
        },
        {
            question: 'Can vermicompost be used for farming and bulk use?',
            answer: 'Yes. Vermicompost is commonly used in farming to improve soil quality and reduce chemical use. Quantity may vary depending on the crop.'
        },
        {
            question: 'What is coco peat used for?',
            answer: 'Coco peat helps soil hold moisture and improves air flow to roots. It is commonly used for seed starting and indoor plants.'
        },
        {
            question: 'Can coco peat be used alone for planting?',
            answer: 'Coco peat does not contain nutrients, so it should be mixed with compost or soil. For best results, use our potting mixture.'
        },
        {
            question: 'What is a potting mixture and how is it used?',
            answer: 'A potting mixture is a ready blend made for pots and containers. It supports healthy roots, good drainage, and plant growth. For best results, use our potting mixture.'
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section id="faqs" className="faq-section">
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">Frequently Asked Questions</h2>
                    <p className="section-subtitle">
                        Easy answers for farmers, gardeners, and home growers
                    </p>
                </div>
                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                        >
                            <button
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                            >
                                <span>{faq.question}</span>
                                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
                            </button>
                            <div className="faq-answer">
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
